export default "__VITE_ASSET__PkRHbZfA__"